import { render, staticRenderFns } from "./new-order.vue?vue&type=template&id=23c1ddfa"
import script from "./new-order.vue?vue&type=script&lang=js"
export * from "./new-order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NewOrderGenreSelect: require('/var/www/frontend/components/new_order/GenreSelect.vue').default,NewOrderAgreementCheckbox: require('/var/www/frontend/components/new_order/AgreementCheckbox.vue').default,NewOrderGenreGuideLink: require('/var/www/frontend/components/new_order/GenreGuideLink.vue').default,Comment: require('/var/www/frontend/components/ui/Comment.vue').default,Music: require('/var/www/frontend/components/ui/Music.vue').default,ListOrderOption: require('/var/www/frontend/components/ui/ListOrderOption.vue').default})
